import gql from 'graphql-tag';


export const jobPostservice = gql`
mutation insert_master_storage_locations($object:jobs_insert_input!) {
  insert_jobs_one(object: $object) {
    id
  }
}
`;

export const getFavSupplier = gql`
subscription getFavSupplier($id: uuid!){
    catalogue_favorites(where:{dental_supplier_id:{_eq:$id}}) {
    id
    catalogue_id
    type
    created_at
    catalogue{
      id
      title
      thumbnail_image
    }
    
  }
}
`;

export const getFavPractice = gql`
subscription getFavPractice($id: uuid!){
    catalogue_favorites(where:{dental_practice_id:{_eq:$id}}) {
    id
    catalogue_id
    type
    created_at
    catalogue{
      id
      title
      thumbnail_image
    }
    
  }
}
`;

export const getFavProfessional = gql`
subscription getFavProfessional($id: uuid!){
    catalogue_favorites(where:{dental_professional_id:{_eq:$id}}) {
    id
    catalogue_id
    type
    created_at
    catalogue{
      id
      title
      thumbnail_image
    }
    
  }
}
`;


export const getFavCats = gql`
subscription getFavCats($tagIdArray: [uuid!]){
    catalogues(where:{id:{_in: $tagIdArray}}){
      id
      title
      thumbnail_image
      
    }
  }
`;



export const removeFavCats = gql`
mutation removeFavCats($id: uuid!) {
  delete_catalogue_favorites(where: {id: {_eq: $id}}){
    affected_rows
  }
}
`;